<div class="g-modal-v2 update-email-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'update_email_modal.title' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <form
    class="g-modal-v2-content"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    @if (state() === 'input') {
      <div class="g-form-control">
        <label
          class="g-form-label"
          for="email"
        >
          {{ 'update_email_modal.enter_new_email' | translate }}
        </label>

        <input
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid(form.controls.email)"
          [formControl]="form.controls.email"
          type="text"
          inputmode="email"
          id="email"
          placeholder="taras.shevchenko@gmail.com"
          appAutofocus
        >

        @if (isControlInvalid(form.controls.email)) {
          <div class="g-form-control-error">
            {{ 'global.required_field' | translate }}
          </div>
        }
      </div>

      @if (error()) {
        <div class="g-form-error">
          {{ error() }}
        </div>
      }
    } @else if (state() === 'otp') {
      <tc-otp
        [otpRequest]="otpRequest()"
        [otpDigitsFormArray]="form.controls.otpDigits"
        [isLoading]="isLoading()"
        [error]="error()"
        (submitted)="onSubmit()"
        (resendOtp)="updateEmailInit()"
      />

      <button
        class="g-main-link go-back"
        [disabled]="isLoading()"
        (click)="goBackFromOtp()"
        type="button"
      >
        {{ 'global.back' | translate }}
      </button>
    } @else if (state() === 'conflict') {
      <tc-merge-accounts
        [identifier]="conflictEmail()"
        [conflictMessage]="conflictMessage()"
        (merged)="onMerged()"
        (cancelled)="onMergeCancelled()"
      />
    } @else {
      <div class="success-header">
        {{ 'update_email_modal.success_header' | translate }}
      </div>
      <div class="success-text g-html-description">
        @if (isMerged()) {
          {{ 'merge_accounts.success_text' | translate }}
        } @else {
          {{ 'update_email_modal.success_text' | translate }}
        }
      </div>
    }

    @if (state() !== 'otp' && state() !== 'conflict') {
      <tc-button
        class="update-email-modal-submit"
        [isLoading]="isLoading()"
        [isDisabled]="isSubmitDisabled()"
        buttonType="submit"
        buttonSize="large"
      >
        @if (state() === 'input') {
          {{ 'global.confirm' | translate }}
        } @else {
          {{ 'global.done' | translate }}
        }
      </tc-button>
    }
  </form>
</div>
